<div class="card d-flex flex-column w-100">
	<div class="p-grid">
		<div class="p-col-12 p-md-6">
			<div class="p-grid">
				<div class="p-col my-auto d-flex">
					<div class="my-auto">Subscription enabled</div>

					<p-inputSwitch styleClass="ms-1" [(ngModel)]="menuItem.subscriptionItem" (onChange)="unsavedChangesChange.emit(true)"></p-inputSwitch>
				</div>
			</div>
			<div class="p-grid mt-4">
				<div class="p-col-12 p-md-6 my-auto d-flex">
					<div class="my-auto">Subscriptions available</div>

					<p-inputSwitch styleClass="ms-1" [(ngModel)]="menuItem.subscriptionAvailable" (onChange)="unsavedChangesChange.emit(true)"></p-inputSwitch>
				</div>
				<div class="p-col-12 p-md-6 d-flex justify-content-end">
					<div class="d-flex flex-column">
						<span class="p-float-label w-100">
							<input
								pInputText
								#subscriptionMaxCount
								name="subscriptionMaxCount"
								type="text"
								[(ngModel)]="menuItem.subscriptionCountMax"
								class="w-100"
								(change)="unsavedChangesChange.emit(true)"
							/>
							<label for="subscriptionMaxCount">Maximum Subscriptions Available</label>
						</span>
						<div class="descriptionText">The maximum number of active subscriptions that this item can have.</div>
					</div>
				</div>
			</div>
			<div class="p-grid mt-4">
				<div class="p-col-12 p-md-6">
					<span class="p-float-label w-100">
						<p-dropdown
							#subscriptionPriceDefault
							[options]="venueService.menuItemPriceOptions(menuItem)"
							optionLabel="label"
							optionValue="value"
							name="subscriptionPriceDefault"
							[(ngModel)]="menuItem.subscriptionPriceNumber"
							[style]="{ width: '100%' }"
							appendTo="body"
							[autoDisplayFirst]="false"
							(onChange)="unsavedChangesChange.emit(true)"
						></p-dropdown>
						<label for="subscriptionPriceDefault">Default Subscription Price</label>
					</span>
				</div>
				<div class="p-col-12 p-md-6">
					<span class="p-float-label">
						<p-multiSelect
							#subscriptionAllowedFrequencyMultiSelect
							[options]="subscriptionFrequencyOptions"
							optionLabel="label"
							optionValue="value"
							name="subscriptionAllowedFrequencyMultiSelect"
							[(ngModel)]="menuItem.subscriptionAllowedFrequencies"
							[style]="{ width: '100%' }"
							appendTo="body"
							[virtualScroll]="true"
							virtualScrollItemSize="30"
							filter="true"
							filterBy="filterByProperties"
							(onChange)="unsavedChangesChange.emit(true)"
						></p-multiSelect>
						<label for="subscriptionAllowedFrequencyMultiSelect">Available Subscription Frequencies</label>
					</span>
				</div>
			</div>
		</div>
		<div class="p-col-12 p-md-6">
			<div class="h4">Subscription History</div>
			<app-menu-item-subscription-history [menuItemKey]="menuItemKey"></app-menu-item-subscription-history>
		</div>
	</div>
</div>
